<div
  class="btn-group navbar-btn"
  dropdown
  [isAnimated]="true"
  [insideClick]="true"
>
  <button id="button" dropdownToggle type="button" class="btn btn-link p-0">
    <img
      *ngIf="userAvatar; else defaultAvatar"
      [src]="userAvatar"
      alt="avatar"
      class="dx-icon avatar"
    />
    <ng-template #defaultAvatar>
      <ng-icon
        name="lucideUser"
        class="text-white fs-4"
        *ngIf="!userAvatar"
      ></ng-icon>
    </ng-template>
  </button>
  <div
    *dropdownMenu
    class="dropdown-menu p-3"
    aria-labelledby="button"
    role="menu"
    style="min-width: 250px"
  >
    <div class="d-flex align-items-center">
      <img
        *ngIf="profile?.profileAvatar; else defaultAvatarMenu"
        [src]="profile?.profileAvatar"
        alt="avatar"
        class="dx-icon avatar"
        width="20"
      />
      <ng-template #defaultAvatarMenu>
        <ng-icon
          name="lucideUser"
          class="dx-icon text-black"
          *ngIf="!profile?.profileAvatar"
        ></ng-icon>
      </ng-template>
      <span class="text-black mx-2">{{ profile?.fullName }}</span>
      <span class="badge badge-pill bg-secondary ms-2">{{
        profile?.defaultPositions
      }}</span>
    </div>
    <div class="border-top border-1 mt-2 pt-2 d-flex align-items-center">
      <ng-icon name="lucideBuilding" class="text-muted fs-4 me-2"></ng-icon>
      <span>{{ profile?.charityTitle }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <ng-icon name="lucidePhone" class="text-muted fs-5 me-2"></ng-icon>
      <span>{{ profile?.mobileNumber }}</span>
    </div>
    <div class="mt-2 d-flex align-items-center">
      <ng-icon name="lucideHandshake" class="text-muted fs-4 me-2"></ng-icon>
      <span>{{ profile?.defaultCooperationType }}</span>
    </div>
    <div class="border-top border-1 mt-2 pt-2">
      <a href="/profile/edit">
        <button class="btn btn-link text-decoration-none text-success ps-0">
          <ng-icon name="lucidePen" class="fs-5 me-2"></ng-icon>
          <span>{{ "homePage.labels.edit" | translate }}</span>
        </button>
      </a>
      <!-- logoff buttton -->
      <br />
      <button
        class="btn btn-link text-decoration-none text-success ms-auto ps-0"
        (click)="logOff()"
      >
        <ng-icon name="lucideLogOut" class="fs-5 me-2"></ng-icon>
        <span>{{ "homePage.labels.logoff" | translate }}</span>
      </button>
    </div>
    <!-- Add more dropdown items here if needed -->
  </div>
</div>
